import React from 'react';
import { getDocumentDisplayName } from '../../helpers/dashboard.helper';

const ImportantDocumentToAccept = ({ pendingChangeRequest }) => {
  return (
    <>
      <div>
        <p>
          The updated <strong>{getDocumentDisplayName(pendingChangeRequest.documentType)}</strong> for your corporate
          GR8PI platform will enter into force in <strong>45 calendar days.</strong>
        </p>
        <p>
          You currently have <strong>45 days remaining</strong> to actively review and accept or decline the updated
          terms.
        </p>
        <p>
          <strong>Review the new {getDocumentDisplayName(pendingChangeRequest.documentType)}</strong>
        </p>
        <p>
          <a href={pendingChangeRequest.documentUrl} target="_blank" rel="noopener noreferrer" className="underline">
            View Full Document Details
          </a>
        </p>
      </div>
      <div className='red'>
        <p>
          <strong>IMPORTANT:</strong> You do not have to take any action if you agree with the new terms (passive
          acceptance will occur after 45 days).
        </p>
        <p>
          <strong>If you decline, your platform will be deleted 90 days after the new terms enter into force.</strong>
        </p>
      </div>
    </>
  );
};

export default ImportantDocumentToAccept;
